import { ConfigProvider } from "antd";
import AppRouter from "./AppRouter";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { ToastProvider } from "./components/Toast/ToastContext";
import { UploadNotificationProvider } from "./context/UploadNotificationContext";
import { InboxReviewConfirmProvider } from "./context/InboxReviewConfirmContext";
import GlobalUploadNotification from "./components/Notification/GlobalUploadNotification";
import GlobalErrorToast from "./components/Notification/GlobalErrorToast";
import { antdTheme } from "./theme/tokens";

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <UploadNotificationProvider>
        <ToastProvider>
          <InboxReviewConfirmProvider>
            <ErrorBoundary>
              <AppRouter />
              <GlobalUploadNotification />
              <GlobalErrorToast />
            </ErrorBoundary>
          </InboxReviewConfirmProvider>
        </ToastProvider>
      </UploadNotificationProvider>
    </ConfigProvider>
  );
}

export default App;
